export const BREAKPOINTS = {
  MOBILE: 320,
  TABLET: 768,
  NOTEBOOK: 1280,
  DESKTOP: 1920
}
